import { Link } from 'react-router-dom';
import { useI18n } from '@/lib/i18n';

export default function NotFound() {
  const { t } = useI18n();
  return (
    <main id="main" className="flex min-h-screen flex-col items-center justify-center gap-3">
      <p className="text-4xl font-bold tabular-nums text-status-error">404</p>
      <p className="text-sm text-ink-muted">{t('nf.message')}</p>
      <Link to="/" className="text-brand underline-offset-4 hover:underline">
        {t('nf.back')}
      </Link>
    </main>
  );
}
